export default "__VITE_ASSET__B41jU3fS__"